import { createSelector } from 'reselect';
import { RootState } from '../store';

const selectTableState = (state: RootState) => state.table;

export const selectLoading = createSelector(
    selectTableState,
    (tableState) => tableState.loading
);

export const selectError = createSelector(
    selectTableState,
    (tableState) => tableState.error
);

export const selectData = createSelector(
    selectTableState,
    (tableState) => tableState.data
);

export const selectFeeGroups = createSelector(
    selectTableState,
    (tableState) => tableState.feeGroups
);

export const selectFilters = createSelector(
    selectTableState,
    (tableState) => tableState.filters
);

export const selectSearchIsActive = createSelector(
    selectTableState,
    (tableState) => tableState.searchIsActive
);

export const selectPaginationTotalRecords = createSelector(
    selectTableState,
    (tableState) => tableState.pagination.totalRecords
);

export const selectPaginationFirst = createSelector(
    selectTableState,
    (tableState) => tableState.pagination.first
);

export const selectPaginationRowsPerPage = createSelector(
    selectTableState,
    (tableState) => tableState.pagination.rowsPerPage
);

export const selectPaginationPage = createSelector(
    selectTableState,
    (tableState) => tableState.pagination.page
);